import React, { useState, useEffect } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const AUTH_TOKEN = "7633d6c7-1111-4fd9-b78c-14e0312957f8";

// Styled Container
const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  minHeight: "100vh",
  backgroundColor: "#F9FAFB",
}));

const TermsAndConditions = () => {
  const [termsData, setTermsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch Terms and Conditions data
    const fetchTerms = async () => {
      try {
        const response = await fetch(`${BASE_URL}/terms-and-conditions`, {
          headers: {
            Authorization: AUTH_TOKEN,
          },
        });

        const data = await response.json();

        if (data.status) {
          setTermsData(data.data);
        } else {
          setError("Failed to fetch Terms and Conditions data.");
        }
      } catch (err) {
        setError("An error occurred while fetching the data.");
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="#F9FAFB"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="#F9FAFB"
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Container>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        {termsData?.title}
      </Typography>
      <Typography
        variant="body1"
        dangerouslySetInnerHTML={{ __html: termsData?.description }}
        sx={{
          fontSize: "16px",
          lineHeight: "1.6",
          color: "#333333",
        }}
      />
    </Container>
  );
};

export default TermsAndConditions;